function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 14,
  cy: 15.9993,
  r: 12,
  fill: "#EBF3FD"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M21.4097 7.51754C21.4097 11.9506 17.9673 12.6391 17.9673 16.7705C17.9673 18.9034 15.8172 19.0831 14.1808 19.0831C12.7673 19.0831 9.6465 18.5468 9.6465 16.7692C9.6465 12.6397 6.26337 11.9513 6.26337 7.51754C6.26337 3.36539 9.90192 -0.000534058 13.8937 -0.000534058C17.8868 -0.000534058 21.4097 3.36539 21.4097 7.51754Z",
  fill: "#FFD983"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M16.7075 22.2779C16.7075 22.848 15.1694 23.9991 13.8386 23.9991C12.5078 23.9991 10.9698 22.848 10.9698 22.2779C10.9698 21.7079 12.5071 21.9337 13.8386 21.9337C15.1694 21.9337 16.7075 21.7079 16.7075 22.2779Z",
  fill: "#CCD6DD"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M17.0778 6.98954C16.8087 6.72035 16.3735 6.72035 16.1044 6.98954L13.8372 9.25666L11.5701 6.98954C11.3009 6.72035 10.8658 6.72035 10.5966 6.98954C10.3274 7.25873 10.3274 7.69384 10.5966 7.96303L13.1488 10.5152V17.8033C13.1488 18.184 13.4572 18.4918 13.8372 18.4918C14.2173 18.4918 14.5257 18.184 14.5257 17.8033V10.5152L17.0778 7.96303C17.347 7.69384 17.347 7.25873 17.0778 6.98954Z",
  fill: "#FFCC4D"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M17.9656 21.2456C17.9656 22.0056 17.3487 22.6225 16.5887 22.6225H11.0809C10.3208 22.6225 9.70398 22.0056 9.70398 21.2456V17.1147H17.9656V21.2456Z",
  fill: "#99AAB5"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M9.7042 21.9343C9.37373 21.9343 9.08182 21.6954 9.02605 21.3588C8.9634 20.9842 9.21676 20.629 9.59198 20.567L17.8536 19.1901C18.2281 19.1226 18.5834 19.3808 18.6453 19.756C18.708 20.1305 18.4546 20.4858 18.0794 20.5477L9.81779 21.9247C9.77993 21.9316 9.74137 21.9343 9.7042 21.9343ZM9.7042 19.1804C9.37373 19.1804 9.08182 18.9415 9.02605 18.6049C8.9634 18.2304 9.21676 17.8751 9.59198 17.8131L17.8536 16.4362C18.2281 16.3694 18.5834 16.6269 18.6453 17.0021C18.708 17.3767 18.4546 17.7319 18.0794 17.7939L9.81779 19.1708C9.77993 19.1777 9.74137 19.1804 9.7042 19.1804Z",
  fill: "#CCD6DD"
});

function SvgLightbulb(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 29 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightbulb);
export default __webpack_public_path__ + "static/media/lightbulb.74966af5.svg";
export { ForwardRef as ReactComponent };